import Swiper, { Autoplay, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let reviewsSwiperWr = document.querySelectorAll('.reviews-swiper-wr');

reviewsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let pagination = el.querySelector('.swiper-pagination');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Pagination],
      observer: true,
      observeParents: true,
      spaceBetween: 14,
      slidesPerView: 1,
      threshold: 10,
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        641: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 18,
        },
        1200: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });
    swiperObserver(swiper);
  }
});